import React, { useState } from 'react';
 import { useFormik } from 'formik';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { Context } from '../components/Context';
import { useContext } from "react";
import HomePage from './homepage';

 // A custom validation function. This must return an object
 // which keys are symmetrical to our values/initialValues
 const validate = values => {
   const errors = {};
   if (!values.username) {
     errors.username = 'Required';
   }
 
   if (!values.password) {
     errors.password = 'Required';
   }
  
   return errors;
 };
 
 const LoginPage = () => {
  const [context, setContext] = useContext(Context);
  const [loginStatus, setLoginStatus] = useState("false")
  const processLoginData = () => {
    let temp = {...context}
    temp.isLoggedIn = !temp.isLoggedIn
    return temp
  }

   // Pass the useFormik() hook initial form values, a validate function that will be called when
   // form values change or fields are blurred, and a submit function that will
   // be called when the form is submitted
   const validateUser = (form_values) => {
      const url = `https://cvkdl78x74.execute-api.us-east-1.amazonaws.com/production/bdp_receipts/` + form_values.username + "%20" + form_values.password 
      fetch(url)
      .then(response => {
          // console.log(response)
          return response.json()
      })
      .then(data => {
          console.log("here")
          console.log(data)
          // setTransactionData(data)
      })
    // console.log(isLoggedIn)
    // isLoggedIn = !isLoggedIn
    console.log(form_values)
    // console.log(isLoggedIn)
    console.log(window.location.href)
   }
   const formik = useFormik({
     initialValues: {
       username: '',
       password: '',
     },
     validate,
     onSubmit: values => {
        // check api for a match
        validateUser(values)

        // if valid user
        if (values.username === "maccaveli" && values.password === "asdf"){
          let temp = {...context}
          temp.isLoggedIn = !temp.isLoggedIn
          setContext(temp)
          setLoginStatus("loggedIn")
          alert(JSON.stringify(values, null, 2));

          // return <TimeClock/>
        }
        else{
          // not a valid user
          setLoginStatus("invalid")
      }
     },
   });
  if ((context.isLoggedIn)) {
    return <HomePage/>
  }
  else {   return (
    <Div>
        <Helmet>
            <meta 
                name="description"  
                content = "Big Dog Properties Login Page"
                />

            <title>Big Dog Properties | Login Page</title>
        </Helmet>
        {loginStatus === "invalid" && <P>Username and password do not match</P>}
        <Form onSubmit={formik.handleSubmit}>
            <FormDiv>
                <label htmlFor="username">email/username </label>
            </FormDiv>
            <FormDiv>    
                <input
                    id="username"
                    name="username"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.firstName}
                />
                {formik.errors.username ? <div>{formik.errors.username}</div> : null}
            </FormDiv> 
            <FormDiv> 
                <label htmlFor="password">password: </label>
        </FormDiv>
            <FormDiv>  
                <input
                    id="password"
                    name="password"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.lastName}
                />
                {formik.errors.password ? <div>{formik.errors.password}</div> : null}
        </FormDiv> 
        <FormDiv> 
                <Button type="submit">Submit</Button>
        </FormDiv> 
        </Form>
        <button onClick={() => setContext(processLoginData())}>
        {"Context value is: " + context.isLoggedIn}
      </button>
     </Div>
   );}
 };

 export default LoginPage

 const getHeight = () => {
    if (window.innerWidth < 475) {
        return window.innerHeight * .35
    }
    else if (window.innerWidth >= 475 && window.innerWidth < 650) {
        return window.innerHeight * .5
    }
    else if (window.innerWidth >= 650 && window.innerWidth < 850) {
        return window.innerHeight * .7
    }
    else if (window.innerWidth >= 850 && window.innerWidth < 1050) {
        return window.innerHeight * .85
    }
    else{
        let height = window.innerHeight * .95;
        return height
    }
  }

const padding_height = () => {return  window.innerHeight * .35}

const P = styled.p`
  color:red;
`;

const Form = styled.form`
    display:block;
 `;
const Div = styled.div`
    width:100%;
    height:${getHeight}px;
    padding-top: ${padding_height}px;
    text-align:center;
    content-justify:center;
    align-items:center;
    // margin:100px;
    // padding:100px;
    // border: solid 2px orange;
`;
 const FormDiv = styled.div`
    width:30%;
    text-align:left;
    content-justify:center;
    align-items:center;
    display:block;
    // border: solid 2px red;
    margin:auto;
    input {
        border-radius: .5rem;
        margin:2px 0;
        padding:1px 0;
        color:black;
    }

`;

const Button = styled.button`
    cursor:pointer;
    background-color: var(--primary-color);
    color:var(--font-light-color);
    border-radius: .5rem;
    padding: .5rem;
    margin:10px 0;

`;

